<template>
  <div>
    <p v-if="!hasChatBlockId">
      chat block id unknown
    </p>
    <player-chat-block-link
      v-if="hasChatBlockId"
      :playerId="action.playerId"
      :chatBlockId="action.chatBlockId"
      lable="chat block"
    />
  </div>
</template>

<script>
import PlayerChatBlockLink from './PlayerChatBlockLink.vue';

export default {
  name: 'UserActionInfoBlockChat',

  components: {
    PlayerChatBlockLink,
  },

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasChatBlockId() {
      return 'chatBlockId' in this.action;
    },
  },
};
</script>
